enum AppRegion {
  CAN = 'CAN',
  US = 'US',
}

export default AppRegion;
